// extracted by mini-css-extract-plugin
module.exports = {"language-settings-spinner":"language-settings_language-settings-spinner__tMuND"};